module.exports = __webpack_public_path__ + "img/3-7.9265dae6.jpg";